import Backbone from 'backbone';
import _ from 'underscore';
import UserFacilitiesCollection from 'common/collections/user-facilities-collection';
import {AnalyticAppErrorMessageEnum} from 'common/proxies/enum-proxy';
import {
  OPEN,
  RESET,
  SELECTION_CHANGED,
  SELECTIONS_CHANGED,
} from 'common/constants';
import SelectorContainerView from 'common/views/selector-container-view';
import './index.scss';

const AppBase = function () {};

AppBase.prototype = _.extend(
  {
    collections: [],
    enabled: true,
    end: undefined,
    initialized: false,
    labels: [],
    page: 1,
    selectors: [],
    start: undefined,

    userFacilitiesCollection: new UserFacilitiesCollection(),

    selectorContainerView: new SelectorContainerView({
      el: $('#selectorContainer'),
    }),

    closeSelectors(id) {
      this.selectors.forEach((selector) => {
        if (selector.el.id !== id) {
          selector.close();
        }
      });
    },

    fetchReportData() {
      // Override
      // Fetches data for the app.
    },

    getPage() {
      return this.page ? this.page : 1;
    },

    getParamsFromUrlFragment() {
      return Backbone.history.fragment.split('/');
    },

    getParamsFromView() {
      let params = this.selectors.map((selector) => selector.getSelectedItem());
      const page = this.getPage();
      if (page) {
        params.push(page);
      }

      params = this.setViewParams(params);
      params = this.validateViewParams(params);
      return params;
    },

    getParamsObj() {
      // Override
      // Turns array of url params into an
      // Object with named attributes.
    },

    hideSelectors() {
      this.selectorContainerView.hide();
    },

    init() {
      const {buildings, tenants} = window.settings.organization;
      if (!buildings.length) {
        return this.showErrorMessage(
          AnalyticAppErrorMessageEnum.NO_FACILITIES.message,
        );
      }
      this.resetUserFacilities({
        buildings,
        tenants,
      });
    },

    renderReportData() {
      // Override
    },

    resetCollections() {
      this.collections.forEach((collection) => {
        collection.reset();
      });
    },

    restoreSelectors(urlFragments) {
      // Override (as needed for dependent selectors).
      // Default implementation assumes the app.selectors
      // Array elements are in the same order as the url fragments
      this.selectors.forEach((selector, index) => {
        if (selector) {
          selector.restoreFromCache(urlFragments[index]);
        }
      });
    },

    resetUserFacilities(orgMetadata) {
      const collection = this.userFacilitiesCollection;
      collection.on(RESET, this.onResetUserFacilities, this);
      collection.reset(orgMetadata, {
        parse: true,
      });
    },

    saveSelectorOptions() {
      // TODO manage the size of the selectors stack
      this.selectors.forEach((selector) => {
        const options = selector.$el.children();
        selector.cachedOptions.push(options);
      });
    },

    setUrlFragment() {
      let params = this.getParamsFromView();
      params = this.validateViewParams(params);
      this.saveSelectorOptions();
      this.trigger(SELECTIONS_CHANGED, params);
    },

    setViewParams(params) {
      // Override
      // Gives an app a chance to mutate
      // Params coming out of selects
      // Before they get set on the URL.
      return params;
    },

    showErrorMessage(message) {
      return message;
      // Override
      // Passes an error message to the
      // Chart view for rendering.
    },

    showSelectors() {
      this.selectorContainerView.show();
    },

    validateSelectionsAgainstUrlFragment() {
      // Override
      // Retrieves params from the URL and
      // Attempts to set them on selectors.
    },

    validateViewParams(params) {
      this.enabled = true;
      for (let ii = 0, nn = params.length; ii < nn; ii++) {
        if (!params[ii]) {
          this.enabled = false;
          params[ii] = '';
        }
      }
      return params;
    },

    onError() {
      this.showErrorMessage(
        AnalyticAppErrorMessageEnum.DATA_LOAD_ERROR.message,
      );
    },

    onOpen(event) {
      this.closeSelectors(event.target.el.id);
    },

    onResetUserFacilities() {
      this.validateSelectionsAgainstUrlFragment();
      this.setUrlFragment();
      this.addSelectorListeners();
      this.showSelectors();
    },

    onSelectionChanged() {
      this.setUrlFragment();
    },

    addSelectorListeners() {
      const that = this;
      this.selectors.forEach((selector) => {
        selector.on(OPEN, (event) => {
          that.onOpen(event);
        });
        selector.on(SELECTION_CHANGED, (event) => {
          that.onSelectionChanged(event);
        });
      });
    },
  },
  Backbone.Events,
);

export default AppBase;
